<template>
  <el-card>
    <!-- <transition name="el-zoom-in-center"> -->
      <div v-if="!completed || !finalstatus" style="height: '500px'">
        <el-steps :acitve="active" align-center>
          <el-step :title="step.title" :status="step.status" :key="index" v-for="(step, index) in steps"></el-step>
        </el-steps>
        <el-card v-loading="loading">
          Running operations
        </el-card>
      </div>
      <!-- <el-timeline :key="step.title" v-for="step in steps">
        <el-timeline-item :title="step.title"></el-timeline-item>
      </el-timeline> -->
    <!-- </transition> -->
    <transition name="el-zoom-in-center">
      <el-result
          v-show="completed && finalstatus"
          icon="success"
          title="Successfully Added"
          subTitle="Password has been emailed successfully! Customer account is ready to login with the temporary password."
        >
        </el-result>
    </transition>
    <transition name="el-zoom-in-center">
      <el-result
          v-show="completed && !finalstatus"
          icon="warning"
          title="Error"
          subTitle=""
        >
        </el-result>
    </transition>

    <!-- <el-button @click="$emit('back')">
      Back
    </el-button> -->
  </el-card>
</template>

<script>
import axios from 'axios';
import { CUSTOMER_API_BASE, PG_API_BASE, AUTH_API_BASE, EMAIL_API_BASE, ADMIN_API_BASE } from '../env';
import { welcomeTemplate } from '../utils/emailTemplates';

export default {
  name: 'CreateCustomerStepConfirm',
  props: {
    customer: { type: Object, required: true },
    edit: { type: Boolean, default: false },
    primaryContact: { type: Object, required: true },
  },
  async mounted() {
    this.loading = true;

    try {
      await this.addCustomer();
    } catch (err) {
      this.loading = false;
      this.completed = true;
      this.finalstatus = false;
      return;
    }
    try {
      await this.enableCrm();
    } catch (err) {
      this.loading = false;
      this.completed = true;
      this.finalstatus = false;
      return;
    }
    try {
      await this.enableBraintree();
    } catch (err) {
      this.loading = false;
      this.completed = true;
      this.finalstatus = false;
      return;
    }
    try {
      await this.setPassword();
    } catch (err) {
      this.loading = false;
      this.completed = true;
      this.finalstatus = false;
      return;
    }
    try {
      await this.sendEmail();
    } catch (err) {
      this.loading = false;
      this.completed = true;
      this.finalstatus = false;
      return;
    }

    // If a customer is convered from a salesforce Customer, change the status there
    if (this.newCustomer.salesforceId) {
      await this.setConverted();
    }

    this.loading = false;
    this.completed = true;
    this.finalstatus = true;

    this.$emit('load', this.finalstatus);
  },
  data() {
    return {
      loading: false,
      newCustomer: null,
      crmAccount: null,
      completed: false,
      steps: [
        { title: 'Add Customer', status: 'success' },
        { title: 'Enable CRM Account', status: 'wait' },
        { title: 'Enable Braintree account', status: 'wait' },
        { title: 'Set password', status: 'wait' },
        { title: 'Send Email', status: 'wait' },
      ],
      active: 0,
    };
  },
  methods: {
    async setConverted() {
      const convertedBy = this.$keycloak.tokenParsed.email;
      try {
        await axios.post(`${ADMIN_API_BASE}/customers/salesforce/convert`, {
          salesforceId: this.newCustomer.salesforceId,
          convertedBy,
        }, {
          headers: {
            Authorization: `Bearer ${this.$keycloak.token}`,
          },
        });
      } catch (err) {
        this.$message.error({
          title: 'error',
          message: err.message ? err.message : err.response.data,
        });
      }
    },
    async addCustomer() {
      try {
        const customerResponse = await axios.post(`${CUSTOMER_API_BASE}/customers/v1`, {
          ...this.customer,
          ...(this.$root.state.facility ? { locations: [this.$root.state.facility] } : {}),
        }, {
          headers: {
            Authorization: `Bearer ${this.$keycloak.token}`,
          },
        });
        this.$message.success({
          title: 'Success',
          message: 'New Customer added successfully.',
        });
        this.newCustomer = customerResponse.data;
        this.steps[0].status = 'success';
      } catch (err) {
        this.steps[0].status = 'error';
        this.$message.error({
          title: 'error',
          message: err.message ? err.message : err.response.data,
        });
        this.error = err.message ? err.message : err.response.data;
        throw new Error();
      }
    },
    async getCrmAccount() {
      const response = await axios.get(`${AUTH_API_BASE}/customers`, {
        params: {
          email: this.customer.email,
        },
        headers: {
          Authorization: `Bearer ${this.$keycloak.token}`,
        },
      });
      this.crmAccount = response.data && response.data.length > 0 ? response.data[0] : null;
    },
    async customerIsEnabledWithCRM() {
      const response = await axios.put(`${CUSTOMER_API_BASE}/customers/v1/${this.newCustomer._id}`, {
        customerId: true,
      }, {
        headers: {
          Authorization: `Bearer ${this.$keycloak.token}`,
        },
      });
      this.newCustomer = response.data;
    },
    async enableCrm() {
      try {
        await axios.post(`${AUTH_API_BASE}/customers`, {
          email: this.customer.email,
          firstName: this.primaryContact.firstName || 'Primary',
          lastName: this.primaryContact.lastName || 'Contact',
          title: this.primaryContact.title,
          username: this.customer.userName,
          emailVerified: true,
          enabled: true,
          attributes: {
            customerId: [this.newCustomer._id],
          },
        },
        {
          headers: {
            Authorization: `Bearer ${this.$keycloak.token}`,
          },
        });
        await this.getCrmAccount();
        await this.customerIsEnabledWithCRM();
        this.steps[1].status = 'success';
        return true;
      } catch (err) {
        this.steps[1].status = 'error';
        this.$message.error({
          title: 'Error',
          message: err.message ? err.message : err.response.data,
        });
        throw new Error();
      }
    },
    async enableBraintree() {
      try {
        await axios.post(`${PG_API_BASE}/customer/create`, {
          id: this.newCustomer._id,
          firstName: this.primaryContact.firstName || 'Primary',
          lastName: this.primaryContact.lastName || 'Contact',
          email: this.customer.email,
          phone: this.customer.phone,
          company: this.customer.company,
        }, {
          headers: {
            Authorization: `Bearer ${this.$keycloak.token}`,
          },
        });
        await axios.put(`${CUSTOMER_API_BASE}/customers/v1/${this.newCustomer._id}`, {
          customerId: true,
        },
        {
          headers: {
            Authorization: `Bearer ${this.$keycloak.token}`,
          },
        });

        this.steps[2].status = 'success';
      } catch (err) {
        this.steps[2].status = 'error';
        this.$message.error({
          title: 'Error',
          message: err.message ? err.message : err.response.data,
        });
        throw new Error();
      }
    },
    async setPassword() {
      try {
        const response = await axios.put(`${AUTH_API_BASE}/customer/${this.crmAccount.id}/reset-password`, {
          value: !this.primaryContact.password ? this.primaryContact.generatedPassword : this.primaryContact.password,
          temporary: this.primaryContact.temporary,
          type: 'password',
        },
        {
          headers: {
            Authorization: `Bearer ${this.$keycloak.token}`,
          },
        });

        this.steps[3].status = 'success';
        this.$message.success({
          title: 'Success',
          message: response.data,
        });
      } catch (err) {
        this.steps[3].status = 'error';
        this.$message.error({
          title: 'Error',
          message: err.message ? err.message : err.response.data,
        });
        throw new Error();
      }
    },
    async sendEmail() {
      try {
        const mjmlTemplate = welcomeTemplate(
          this.primaryContact.firstName, this.customer.email, this.primaryContact.password ? this.primaryContact.password : this.primaryContact.generatedPassword,
        );
        await axios.post(`${EMAIL_API_BASE}/send/email`, {
          from: this.$keycloak.tokenParsed.email,
          to: this.customer.email,
          facility: this.$root.state.facility ? this.$root.state.facility : null,
          customer: this.newCustomer._id,
          subject: 'Welcome to ReadySpaces',
          mjml: true,
          body: mjmlTemplate,
        }, {
          headers: {
            Authorization: `Bearer ${this.$keycloak.token}`,
          },
        });
        this.steps[4].status = 'success';
      } catch (err) {
        this.steps[4].status = 'error';
        this.$message.error({
          title: 'Error',
          message: 'Send email failed',
        });
        throw new Error();
      }
    },
  },
};
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/CreateCustomerStepConfirm.vue